import {AxiosResponse} from 'axios';
import {orgAPI} from '@/core/api';
import {API_URL} from '../enums/api-url.enum';
import {
  ICustomizationTemplate,
  IEmailTemplate,
  IEmailTemplateResponse,
  ITemplate,
} from '../types/organization-communication.interface';
import {EMAIL_TEMPLATE_TYPE} from '../enums';

class CommunicationService {
  static createCustomizationTemplate = async (reqBody: ICustomizationTemplate): Promise<AxiosResponse<any>> =>
    orgAPI.post(API_URL.CREATE_CUSTOMIZATION_TEMPLATE, reqBody);

  static presignedImage = async (): Promise<AxiosResponse> =>
    orgAPI.get(API_URL.GET_PRESIGNED_CUSTOMIZATION_TEMPLATE_IMAGE);

  static getCommunicationTemplate = async (id: number): Promise<AxiosResponse> =>
    orgAPI.get(`${API_URL.GET_CUSTOMIZATION_TEMPLATES}/${id}`);

  static sendCustomizationTemplate = async (eventId: number): Promise<AxiosResponse<any>> =>
    orgAPI.post(`${API_URL.SEND_CUSTOMIZATION_EMAIL}?eventId=${eventId}`);

  static getAllTemplateTypes = async (eventId: number): Promise<AxiosResponse<ITemplate[]>> =>
    orgAPI.get(`${API_URL.GET_All_TEMPLATES_TYPES}?eventId=${eventId}`);

  static getOneTemplateByType = async (
    eventId: number,
    templateType: EMAIL_TEMPLATE_TYPE
  ): Promise<AxiosResponse<IEmailTemplateResponse>> =>
    orgAPI.get(`${API_URL.GET_All_TEMPLATES}/${templateType}?eventId=${eventId}`);

  static updateOrCreateTemplate = async (
    templateType: EMAIL_TEMPLATE_TYPE,
    reqBody: IEmailTemplate
  ): Promise<AxiosResponse<IEmailTemplateResponse>> =>
    orgAPI.put(`${API_URL.GET_All_TEMPLATES}/${templateType}`, reqBody);

  // send email template
  static sendEmailTemplate = async (eventId: number, templateType: EMAIL_TEMPLATE_TYPE): Promise<AxiosResponse> =>
    orgAPI.post(`${API_URL.SEND_EMAIL_TEMPLATE}/${templateType}?eventId=${eventId}`);

  // send test email template
  static sendTestEmailTemplate = async (eventId: number, templateType: EMAIL_TEMPLATE_TYPE): Promise<AxiosResponse> =>
    orgAPI.post(`${API_URL.SEND_TEST_EMAIL_TEMPLATE}/${templateType}?eventId=${eventId}`);

  //ticket invoice templates
  static sendTicketInvoiceTemplate = async (eventId: number): Promise<AxiosResponse<any>> =>
    orgAPI.post(`${API_URL.SEND_TICKET_INVOICE_EMAIL}?eventId=${eventId}`);

  //invoice email templates
  static sendInvoiceEmailTemplate = async (eventId: number): Promise<AxiosResponse<any>> =>
    orgAPI.post(`${API_URL.SEND_INVOICE_EMAIL}?eventId=${eventId}`);

  //notify auction winners
  static notifyAuctionWinners = async (eventId: number): Promise<AxiosResponse<any>> =>
    orgAPI.post(`${API_URL.SEND_WINNERS_EMAIL}?eventId=${eventId}`);

  //send attendee ticket personally
  static emailAttendeeTicket = async (attendeeId: number): Promise<AxiosResponse<any>> =>
    orgAPI.post(`${API_URL.SEND_ATTENDEE_TICKET}/${attendeeId}`);

  //send attendee receipt personally
  static emailAttendeeReceipt = async (attendeeId: number): Promise<AxiosResponse<any>> =>
    orgAPI.post(`${API_URL.SEND_ATTENDEE_RECEIPT}/${attendeeId}`);
}

export {CommunicationService};
